import IssueRequestForm from "../components/shared/IssueRequestForm";
import '../scss/pages/IssueRequest.scss';
import {useEffect, useState } from "react";
import AlertModal from "../components/shared/AlertModal";
import {useForm} from "react-hook-form";
import axios from "axios";
import { useOktaAuth } from "@okta/okta-react";
import {useDispatch} from 'react-redux';

// react-bootstrap components
import {
    Button,
    Card,
    Container,
    Row,
    Col,
    Modal,
} from "react-bootstrap";
import useRequestToken from "../hooks/useRequestToken";
import useAuthorization from "../hooks/useAuthorization";
import {useSelector} from 'react-redux';
import { Link, useHistory } from "react-router-dom";
import { fetchProfileAsync, selectUser } from "../features/user/userSlice";
import { setPendingIssue } from "../features/issue/issueSlice";
import useFileHelper from "../hooks/useFileHelper";
import { useAccount, useMsal } from "@azure/msal-react";
const IssueRequest = () => {
    const { instance, accounts } = useMsal();
    const account = useAccount(accounts[0]);
    const history = useHistory();
    const [showSuccess, setShowSuccess] = useState(false);
    const [showError, setShowError] = useState(false);
    const [showSuccessNoAuth, setShowSuccessNoAuth] = useState(false);
    const [showSuccessWithFileError, setShowSuccessWithFileError] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const {register, handleSubmit, reset, setValue, formState: {errors}} = useForm({
        defaultValues: {
            CertFlag: 'false',
            MedAffairsAssignment: 'true'
        }
    });

    const [email, setEmail] = useState('');
    const dispatch = useDispatch();
    const user = useSelector(selectUser);
    const [getToken] = useRequestToken();
    const [getBase64] = useFileHelper();
    const [errorMessage, setErrorMessage] = useState('');

    useEffect(() => {
        if (user?.email) {
            setValue('email', user?.email)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user])

    const handleSubmitError = (err) => {
      console.log(err, 'error')
    }

    const otherDetails = (claims, value) => {
      let firstName = '';
      let lastName = '';
      let email = '';
      if (claims) {
        const nameParts = claims.name.split(' ');
        firstName = nameParts[0];
        lastName = nameParts[1];
        email = claims.email;
      }

      return {
        firstName: firstName || value.firstName,
        lastName: lastName || value.lastName,
        email: email || value.email
      }
    }
    const handleSubmitIssue = (value) => {
        setIsLoading(true);
        const ssoId = account?.idTokenClaims?.uid || account?.idTokenClaims?.sub;
        const issueCategoryParts = value.IssueCategory.split('/');
        const payload = {
            requestToken: getToken(50),
            ssoUserId: ssoId,
            issueCategory: issueCategoryParts[0],
            issueDesc: value.IssueDesc,
            certFlag: !!value.CertOnBehalfOf,
            certOnBehalfOf: value.CertOnBehalfOf ? value.CertOnBehalfOf : '',
            status: 'PENDING',
            ssoMediatorUserId: issueCategoryParts[1],
            createdBy: ssoId || null,
            recaptcha: value.recaptchaToken,
            ...otherDetails(account?.idTokenClaims, value)
        };
        setEmail(value.email);
        delete payload.issueFile;
        axios.post(process.env.REACT_APP_API_ENDPOINT + 'compliance/request', payload).then((response) => {
            dispatch(setPendingIssue({
                requestId: response.data.requestToken,
                email: value.email,
                firstname: value.firstName,
                lastname: value.lastName
            }));
            if (value.issueFile && value.issueFile.length > 0) {
                getBase64(value.issueFile[0]).then(base64File => {
                    axios.post(process.env.REACT_APP_API_ENDPOINT + 'compliance/request/upload', {
                        fileAttachment: base64File.split(',')[1],
                        fileName: value.issueFile[0].name,
                        requestToken: response.data.requestToken,
                        createdBy: account?.idTokenClaims?.name || value.email
                    }).then((fileResponse) => {
                        if (account) {
                            setShowSuccess(true);
                        } else {
                            setShowSuccessNoAuth(true);
                        }
                        reset();
                        setIsLoading(false);
                    }).catch(() => {
                        setShowSuccessWithFileError(true);
                        setShowSuccess(true);
                    })
                }).catch(() => {
                    setShowSuccessWithFileError(true);
                    setShowSuccess(true);
                });
            } else {
                if (account) {
                    setShowSuccess(true);
                } else {
                    setShowSuccessNoAuth(true);
                }
                reset();
                setIsLoading(false);
            }
        }, err => {
            const serverMessage = err?.response?.data?.message
                || err?.response?.data?.error
                || err?.response?.data
                || '';
            const message = err?.message || 'An unexpected error occurred';
            setErrorMessage(serverMessage ? `${message}: ${serverMessage}` : message);
            setShowError(true);
            setIsLoading(false);
        });
    }

    const handleCloseSuccess = () => {
        setShowSuccess(false);
        setShowSuccessWithFileError(false);
        if (!user) {
          dispatch(fetchProfileAsync())
        }
        history.push('/requests');
    }

    const handleCloseError = () => {
        setShowError(false);
    }

    const handleCloseNoAuth = () => {
        setShowSuccessNoAuth(false);
        setShowSuccessWithFileError(false);
    }

    return (<>
        <Container fluid className="mt-20">
            <Row>
                <Col lg="12">
                    <Card className="card-stats">
                        <Card.Body>
                            <IssueRequestForm setValue={setValue} isLoading={isLoading} handleSubmit={handleSubmit} errors={errors} register={register}
                                              handleSubmitIssue={handleSubmitIssue} handleSubmitError={handleSubmitError}></IssueRequestForm>
                            <AlertModal
                                show={showSuccess}
                                handleClose={handleCloseSuccess}
                                modalTitle={'Issue/Request Submitted'}
                                modalBody={'You have successfully sent an issue/request.' + (showSuccessWithFileError ? ' However file upload did not push through.': '')}
                                handleConfirmButton={handleCloseSuccess}
                                confirmButton={'Close'}>
                            </AlertModal>
                            <AlertModal
                                show={showError}
                                handleClose={handleCloseError}
                                modalTitle={'Issue/Request Error'}
                                modalBody={"You encountered an error, please let your EssilorLuxottica representative know by copying and sharing the response below. The EssilorLuxottica representative will then notify IT and share your details to a member of the Medical Affairs team will then directly contact you within 14 calendar days."}
                                errorMessage={errorMessage}
                                handleConfirmButton={handleCloseError}
                                confirmButton={'Close'}>
                            </AlertModal>
                            <Modal show={showSuccessNoAuth} onHide={handleCloseNoAuth}>
                                <Modal.Header closeButton>
                                    <Modal.Title>Success!</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <p>You have successfully submitted the issue request. We will email you a link shortly with your issue. When the specialist emails submits a response you will receive another email with the same link. This is the only way you can access the request you submitted.</p>
                                    <p><strong>NOTE - </strong>Please check your SPAM and/or PROMOTIONS folder in your email box. We will send you an email from: no-reply@essilorusa.com with the subject that starts with "Essilor Medical Affairs..."</p>
                                    {showSuccessWithFileError && <p>However file upload did not push through.</p>}
                                    {/*<p>You can login <Link onClick={handleCloseNoAuth} to={'/login'}>here</Link>. (with your EssilorPRO login) or you can register <Link onClick={() => { setShowSuccessNoAuth(false) }} to={'/register'}>here</Link> or you can see your request.</p>*/}
                                </Modal.Body>
                                <Modal.Footer>
                                    {/*<Button as={Link} to={'/login'} variant="primary btn-fill" onClick={handleCloseNoAuth}>*/}
                                    {/*    Login*/}
                                    {/*</Button>*/}
                                    {/*<Button as={Link} to={{*/}
                                    {/*  pathname: "/register",*/}
                                    {/*  state: {email}*/}
                                    {/*}}*/}
                                    {/*variant="secondary btn-fill" onClick={handleCloseNoAuth}>*/}
                                    {/*    Register*/}
                                    {/*</Button>*/}
                                </Modal.Footer>
                            </Modal>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    </>)
}

export default IssueRequest;
